<div>
  <div class="row ml-0 mr-0">
    <div class="col-12 mt-2">
      <span class="browse-text mr-3">{{ browseText }}</span>
      <span class="icon-pin attachment-icon"></span>
      <input
        data-cy="file-upload"
        id="btnBrowse"
        title="{{ browseText }}"
        #file
        button
        type="file"
        accept=".csv,.png,.jpeg,.jpg,.pdf,.xls,.xlsx"
        (change)="selectFile($event.target.files)"
        [multiple]="getMultipleStatus()"
        [disabled]="uploadFiles.length >= maxFilesLimit"
      />
    </div>
    <div class="col-12 mt-2 lbl-text" data-cy="file-restriction-info">File must be in a CSV, JPG, JPEG, PNG, PDF, XLS, or XLSX format and cannot exceed 100 MB.</div>

    <div name="fileName" class="col-12 mt-2">
      <table class="float-right">
        <tbody>
          @for (fileInfo of uploadFiles; track fileInfo) {
            <tr>
              <td data-cy="uploaded-file" class="browse-text">
                {{ fileInfo.name }}
              </td>
              <td>
                <button data-cy="remove-file" title="Remove attachment" type="button" class="close ml-2 mb-1" aria-label="Remove file" (click)="deleteFile(fileInfo)">
                  <span aria-hidden="true">&times;</span>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
